module.exports = __webpack_public_path__ + "img/1080x1600.7cb30f0a.svg";